/* eslint-disable max-params, max-lines-per-function */
'use strict';

angular.module('webAgro1App').controller('FuncaoCtrl', function($scope, $rootScope, $routeParams, $location,
  Flash, FuncoesService, LoadingService, MessagesService, StorageService, UsuariosService, PermissionsService) {
  const initialize = function() {
    LoadingService.showLoading();
    $rootScope.initialize.then(function() {
      if (!$rootScope.permissions.funcao.canManage) {
        $location.path('/');
        Flash.create(ACESSO_NAO_PERMITIDO.type, ACESSO_NAO_PERMITIDO.msg);
        return;
      }

      if ($routeParams.id) {
        const error = function() {
          Flash.create(REGISTRO_NAO_EXISTE.type, REGISTRO_NAO_EXISTE.msg);
          $location.path('/funcoes');
        };

        FuncoesService.get($routeParams.id).then(function(funcao) {
          $scope.newFuncao = funcao;

          if (!$scope.$root.parametros.nao_cliente_agrogestao) {
            $scope.newFuncao.itens = $scope.newFuncao.itens.filter((item) => (
              !FuncoesService.funcoesNaoClienteAgrogestao.includes(item.id)
            ));
          }
        }, error)
          .finally(LoadingService.hideLoading);
      } else {
        FuncoesService.createObjectFuncao().then(function(funcao) {
          $scope.newFuncao = funcao;

          if (!$scope.$root.parametros.nao_cliente_agrogestao) {
            $scope.newFuncao.itens = $scope.newFuncao.itens.filter((item) => (
              !FuncoesService.funcoesNaoClienteAgrogestao.includes(item.id)
            ));
          }

          if (funcao.modulos.length <= 0) {
            MessagesService.alert('Não existem módulos cadastrados.');
          }
        }, function() {
          MessagesService.alert('Não foi possível localizar os módulos.');
        })
          .finally(LoadingService.hideLoading);
      }
    }, $rootScope.errorRootInitialize);
  };

  $scope.save = function(form) {
    if (form.$invalid) {
      return;
    }

    LoadingService.showLoading();
    FuncoesService.save($scope.newFuncao).then(function(result) {
      LoadingService.hideLoading();

      // reloads user permissions
      // adapted from $rootScope.initWeb @ controllers/base.js
      const userStored = StorageService.get(KEY_USER) || {};
      UsuariosService.listUsuario(userStored.id).then(function(results) {
        userStored.funcao.permissions = results.data.funcao.permissions.map((permission) => {
          const acoes = permission.acoes.map((acao) => acao.toLowerCase());

          return { ...permission, acoes };
        });

        StorageService.set(KEY_USER, userStored);
        $rootScope.permissions = PermissionsService.get((results.data.funcao || {}).permissions || []);
      });

      $location.path(`/funcoes/${result.data.id}`);
      Flash.create(REGISTRO_SALVO_COM_SUCESSO.type, REGISTRO_SALVO_COM_SUCESSO.msg);
    }, function(error) {
      LoadingService.hideLoading();

      if (error.data && error.data.itens) {
        Flash.create(FALHA_AO_SALVAR_REGISTRO.type, 'É obrigatório selecionar no mínimo uma permissão.');
      } else {
        Flash.create(FALHA_AO_SALVAR_REGISTRO.type, FALHA_AO_SALVAR_REGISTRO.msg);
      }
    });
  };

  $scope.goToIndex = function() {
    $location.path('/funcoes');
  };

  initialize();
});
